import { useLang } from "../i18n/LanguageContext";
import { GiBookmarklet, GiMoon, GiWaterDrop } from "react-icons/gi";

const COPY = {
  pl: {
    eyebrow: "Doświadczenie użytkownika",
    title: "Co zostaje po odczycie snu",
    items: [
      {
        icon: GiMoon,
        label: "Sen powracający",
        quote: "Ten sam symbol wrócił w kilku snach. Dopiero wtedy zaczął tworzyć większą opowieść.",
        meta: "Księga Snów · symbole",
      },
      {
        icon: GiWaterDrop,
        label: "Nastrój i notatka",
        quote: "Po kilku dniach ważna była nie tylko interpretacja, ale też nastrój i własne słowa zapisane przy śnie.",
        meta: "notatka · odczyt",
      },
      {
        icon: GiBookmarklet,
        label: "Osobisty atlas",
        quote: "Z czasem pojedyncze odczyty zaczęły układać się w prywatny język snów.",
        meta: "Atlas Symboli · historia",
      },
    ],
  },
  en: {
    eyebrow: "User experience",
    title: "What remains after a dream reading",
    items: [
      {
        icon: GiMoon,
        label: "Recurring dream",
        quote: "The same symbol returned in several dreams. Only then did it begin to form a larger story.",
        meta: "Dream Codex · symbols",
      },
      {
        icon: GiWaterDrop,
        label: "Mood and note",
        quote: "Days later, the meaning mattered, but so did the mood and the words saved with the dream.",
        meta: "note · reading",
      },
      {
        icon: GiBookmarklet,
        label: "Personal atlas",
        quote: "Over time, single readings began to form a private dream language.",
        meta: "Symbol Atlas · history",
      },
    ],
  },
};

export const ExperienceSection = () => {
  const { lang } = useLang();
  const copy = COPY[lang] ?? COPY.pl;

  return (
    <section
      className="bg-parchment-dark py-24 md:py-32 border-y border-ink/10"
      data-ui="home-experience"
      data-testid="experience-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-accent text-[11px] uppercase tracking-[0.3em] text-gold-muted">
            {copy.eyebrow}
          </span>
          <h2 className="font-heading italic text-4xl md:text-5xl text-ink mt-3">
            {copy.title}
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {copy.items.map((item, index) => {
            const Icon = item.icon;
            return (
              <figure
                key={item.label}
                className="ornate-frame bg-parchment p-1"
                data-ui="home-experience-card"
                data-testid={`experience-card-${index}`}
              >
                <div className="bg-parchment p-8 md:p-10 h-full flex flex-col">
                  <div className="flex items-center justify-between gap-4">
                    <div className="font-accent text-[10px] uppercase tracking-[0.28em] text-gold-muted">
                      {item.label}
                    </div>
                    <Icon className="text-3xl text-ink-soft/60" />
                  </div>
                  <blockquote className="font-heading italic text-xl text-ink leading-snug mt-8 flex-1">
                    {item.quote}
                  </blockquote>
                  <figcaption className="mt-8 pt-6 border-t border-ink/10 font-body italic text-sm text-ink-soft">
                    {item.meta}
                  </figcaption>
                </div>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};
